import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JobGuard } from '@core/guards/job.guard';
import { QuicklinkSharedModule } from '@core/ngx-quicklink.shared.module';
import { LayoutComponent } from '@features/jobs-unlogged/layout/layout.component';
import { ViewComponent } from '@features/jobs-unlogged/view/view.component';
import { MiniListComponent } from '@features/jobs/mini-list/mini-list.component';
import { JobRoutingEnum } from '@routing/job/job-routing.enum';

const routes: Routes = [
  {
    path: JobRoutingEnum.Root,
    component: LayoutComponent,
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            children: [
              {
                path: '',
                component: ViewComponent,
                canActivate: [JobGuard],
              },
              {
                path: '',
                component: MiniListComponent,
                outlet: 'aux',
              },
            ],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), QuicklinkSharedModule],
  exports: [RouterModule],
})
export class JobUnloggedRoutingModule {}
